import React from "react";
import ExpandePublicLayout from "./ExpandePublicLayout";

export default function ExpandePrivacyPage() {
  return (
    <ExpandePublicLayout title="Política de privacidad | Expande">
      <section className="expub-section">
        <p className="expub-kicker">Política de privacidad</p>
        <h1>Política de privacidad de Expande</h1>
        <p>
          Última actualización: 17 de septiembre de 2026. Esta política explica cómo Expande
          Bolivia trata la información de las personas que usan la app móvil y los servicios
          relacionados.
        </p>
        <p>
          Responsable de la app: Jose Maria Rodriguez. Contacto para soporte y privacidad:
          {" "}
          <a href="mailto:soporte@misterquillo.com">soporte@misterquillo.com</a>.
        </p>
      </section>

      <section className="expub-section">
        <h2>Datos que tratamos</h2>
        <p>
          Expande puede tratar datos básicos de cuenta, como nombre, apellido, correo electrónico,
          teléfono, fecha de nacimiento opcional, redes sociales opcionales, rol de usuario y código
          interno de sorteo. También puede tratar información de uso necesaria para interactuar con
          clubes saludables, como membresías, pedidos, asistencias, tickets de soporte, notificaciones
          y actividad operativa dentro de la app.
        </p>
        <p>
          La app no está diseñada para recoger datos médicos ni datos de salud clínica. Los clubes
          pueden vender o mostrar productos saludables, pero Expande no solicita diagnósticos,
          historiales médicos ni información clínica.
        </p>
      </section>

      <section className="expub-section">
        <h2>Inicio de sesión</h2>
        <p>
          Puedes crear o acceder a tu cuenta con correo y contraseña, Google o Sign in with Apple.
          Si usas Sign in with Apple y eliges ocultar tu correo, Apple puede proporcionarnos un
          correo privado relay para operar tu cuenta. Usamos estos proveedores para autenticarte y
          proteger el acceso a la app.
        </p>
      </section>

      <section className="expub-section">
        <h2>Uso de la información</h2>
        <ul>
          <li>Crear y mantener tu cuenta de Expande.</li>
          <li>Permitir interacción con clubes saludables, productos, pedidos y membresías.</li>
          <li>Gestionar soporte, seguridad, recuperación de contraseña y verificación de correo.</li>
          <li>Mantener registros operativos necesarios para el funcionamiento del servicio.</li>
        </ul>
      </section>

      <section className="expub-section">
        <h2>Servicios y encargados</h2>
        <p>
          Expande usa servicios técnicos para operar la app, como infraestructura backend y base de
          datos, envío de correos transaccionales y proveedores de autenticación como Google y Apple.
          Estos servicios se usan únicamente para prestar y proteger el funcionamiento de la app.
        </p>
      </section>

      <section className="expub-section">
        <h2>Conservación y eliminación de cuenta</h2>
        <p>
          Puedes iniciar la eliminación de tu cuenta desde la app, en la sección de perfil. Al eliminar
          una cuenta, se cierra la sesión, se bloquea el acceso y se anonimiza la información personal
          de la cuenta. Algunos registros operativos pueden conservarse de forma anonimizada cuando
          sean necesarios para reportes, seguridad, obligaciones legales o continuidad operativa.
        </p>
        <p>
          Si tu cuenta administra un club o tiene responsabilidades administrativas, la eliminación
          puede requerir una transferencia previa de responsabilidades. En ese caso, la app mostrará
          un mensaje y podrás contactar a soporte.
        </p>
      </section>

      <section className="expub-section">
        <h2>Tus opciones</h2>
        <p>
          Puedes actualizar datos de tu perfil desde la app. También puedes escribir a
          {" "}
          <a href="mailto:soporte@misterquillo.com">soporte@misterquillo.com</a>
          {" "}
          para consultas sobre privacidad, acceso, corrección o eliminación de información.
        </p>
      </section>
    </ExpandePublicLayout>
  );
}
